module.exports = __webpack_public_path__ + "img/FirstAidBook.c843afff.png";